export const MATCH_TUNING = Object.freeze({
  durationSeconds: 300,
  countdownSeconds: 3,
  goalExplosionSeconds: 1.6,
  replaySeconds: 4.5,
  replayHistorySeconds: 3.5,
  goalExplosionRadius: 15,
  goalExplosionImpulse: 12_000,
  demolitionRespawnSeconds: 3,
  demolitionSpeedRatio: 0.92,
  demolitionMinimumApproach: 0.58,
});
